<template>
  <div class="footer-text">
    <span>版权所有 ©广州信瑞医疗技术有限公司</span>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
.footer-text {
  line-height: 40px;
  text-align: center;
  margin: 0 auto;
}
</style>
